import googleOAuth from './google';
// import facebookOAuth from './facebook';
import { Brax3thPartyAuthProvider, BraxOAuthResponse } from '../../components/Brax3thPartyAuthButton';

type SuccessResponse = BraxOAuthResponse & { redirect: string }

export type ProviderRedirectResponse = SuccessResponse | Partial<SuccessResponse> & { error: 'permissions-denied' | 'invalid-response' | 'unknown-provider' };

export type ProviderCallbackResponse = BraxOAuthResponse | 'permissions-denied' | Error | { error: any };

export type ProviderCallback = (response: ProviderCallbackResponse) => void;

export type ProviderPermissions = string[];

export type Provider = (new (permissions: ProviderPermissions, redirectURI: string, callback: ProviderCallback) => {
    connect: (target?: string) => void
}) & {
    handleRedirect: () => ProviderRedirectResponse
};

export const handleOAuthRedirect = (provider: Brax3thPartyAuthProvider): ProviderRedirectResponse =>
    provider in oAuth === false ? { error: 'unknown-provider' } : oAuth[provider].handleRedirect();

const oAuth: { [key in Brax3thPartyAuthProvider]: Provider } = { google: googleOAuth /* , facebook: facebookOAuth */ };

export default oAuth;
